import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const Container = styled.div`
  height: ${props => props.height}px;
`;

const Spacer = ({ height }) => <Container height={height} />;

Spacer.propTypes = {
  height: PropTypes.number,
};

Spacer.defaultProps = {
  height: 10,
};

export default Spacer;
